import React from 'react';
import { assetPrefix } from '../../../utils/assetPrefix';

import { Text } from '../../shared/Text';

export const RefinanceCta = ({ isMobile }: { isMobile?: boolean }) => {

    const { alt, src } = getImageProps();

    return (
        <div
            className={`c-refinance-cta`}>
            <Text as="h2">
							Bereken wat je per maand kunt besparen
            </Text>
						<Text as="p">
							Deze berekening is een hulpmiddel om inzicht te geven in de mogelijkheden en geeft een eerste indicatie of oversluiten voordelig zou kunnen zijn. Voor een volledig beeld of oversluiten voor jou mogelijk is en lonend kan zijn, adviseren we om altijd een gesprek met jouw hypotheekadviseur in te plannen.</Text>
            <img className="c-refinance-cta__image" alt={alt} src={`${assetPrefix}${src}`} />
        </div>
    );
};

function getImageProps(): { src: string; alt: string } {
	return {
		src: '/assets/img.png',
		alt: 'Overwaarde huis berekenen',
	};
}
